// import React, { useEffect, useState } from "react";
// import MainLayout from "./layouts/MainLayout";
// import { useNavigate } from "react-router-dom";
// import AlertCircle from "@untitled-ui/icons-react/build/esm/AlertCircle";
// import { Button, Modal, Typography } from "antd";


// export default function PageNotFound(props) {
//   const { Title, Paragraph } = Typography;
//   const [isModalVisible, setIsModalVisible] = useState(true);
//   const navigate = useNavigate();

//   const handleGoBack = () => {
//     navigate(-1); 

//   };

//   return (
//     <MainLayout>
//       {/* PAGE NOT FOUND! */}
//       <Modal
//         visible={isModalVisible}
//         footer={null}
//         closable={false}
//         centered
//         width={500}
//       >
//         <div style={{ padding: "24px 0" }}>
//           <div
//             className=""
//             style={{
//               display: "flex",
//               justifyContent: "left",
//               flexDirection: "column",
//             }}
//           >
//             <div
//               style={{
//                 display: "flex",
//                 justifyContent: "center",
//                 alignItems: "center",
//                 width: "64px",
//                 height: "64px",
//                 borderRadius: "50%",
//                 backgroundColor: "#fff7e6",
//                 marginBottom: "16px",
//               }}
//             >
//               <AlertCircle style={{ fontSize: "24px", color: "#fa8c16" }} />
//             </div>
//             <Title level={3} style={{ marginTop: 16 }}>
//               Module Not Activated for Licensee
//             </Title>
//           </div>
//        <Paragraph style={{ color: "#666", fontSize: 14, marginBottom: 40 }}>
//             Click on the button below to go back to the previous page
//           </Paragraph>

//           <div style={{ display: "flex", justifyContent: "flex-end" }}>
//             <Button
//               type="primary"
//               style={{
//                 width: "40%",
//                 backgroundColor: "#BA24D5",
//                 color: "white",
//                 height: "44px",
//               }}
//               onClick={handleGoBack}
//             >
//               Close
//             </Button>
//           </div>
//         </div>
//       </Modal>
//     </MainLayout>
//   );
// }


import React, { useEffect, useState } from "react";
import MainLayout from "./layouts/MainLayout";
import { useNavigate } from "react-router-dom";
import AlertCircle from "@untitled-ui/icons-react/build/esm/AlertCircle";
import { Button, Modal, Typography } from "antd";

export default function PageNotFound() {
  const { Title, Paragraph } = Typography;
  const [isModalVisible, setIsModalVisible] = useState(true);
  const navigate = useNavigate();

  const handleGoBack = () => {
    navigate(-1);
  };

  return (
    <MainLayout>
      <Modal
        open={isModalVisible}
        footer={null}
        closable={false}
        centered
        width={500}
        bodyStyle={{ padding: 32 }}
      >
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            textAlign: "center",
          }}
        >
          <div
            style={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              width: 85,
              height: 85,
              borderRadius: "50%",
              backgroundColor: "#fff7e6",
              marginBottom: 5,
            }}
          >
            <AlertCircle style={{ fontSize: 24, width:48,height:48, color: "#fa8c16" }} />
          </div>

          <Title level={4} style={{ marginBottom: 8 }}>
            Module Not Activated for Licensee
          </Title>

          <Paragraph style={{ color: "#666", fontSize: 14, marginBottom: 32 }}>
            Click the button below to go back to the previous page.
          </Paragraph>

          <Button
            type="primary"
            style={{
              backgroundColor: "#BA24D5",
              color: "white",
              width: "100%",
              height: 44,
            }}
            onClick={handleGoBack}
          >
            Close
          </Button>
        </div>
      </Modal>
    </MainLayout>
  );
}
